<plex-title titulo="Calendario"></plex-title>
<div class="mb-2">
    <plex-datetime label="Buscar por fecha" type="date" [(ngModel)]="fechaSelector" name="filtroFecha"
                   (change)="onChangeFecha($event)"></plex-datetime>
</div>